<template>
  <div class="video">
    <div>
      <el-button
        @click="videoDialog = true"
        type="primary"
        v-auth="'classRoomTeaching_/attachmentObject/addAttachmentRecording'"
        >添加视频</el-button
      >
      <el-table
        v-auth="'classRoomTeaching_/attachmentObject/recordingPageList'"
        :data="videoList"
        border
        style="width: 100%; margin-top: 20px"
        @selection-change="selectionVideoChange"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column
          prop="attachment.name"
          label="视频名称"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.attachment.name }}
              <el-tag v-if="scope.row.courseType == 2">自建</el-tag>
              <el-tag type="warning" v-else>同步</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="attachment.size" label="大小">
          <template slot-scope="scope"
            >{{
              (scope.row.attachment.size / 1024 / 1024).toFixed(4)
            }}MB</template
          >
        </el-table-column>
        <el-table-column
          prop="attachment.createTime"
          label="上传时间"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column prop label="操作" width="160" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                v-auth="'classRoomTeaching_/attachment/updateAttachment'"
                style="font-size: 16px; margin-right: 10px"
                class="el-icon-edit mainColor"
                @click="edit(scope.row)"
              ></i>
              <i
                v-auth="'classRoomTeaching_/attachmentObject/down'"
                style="font-size: 16px; margin-right: 10px"
                class="el-icon-bottom mainColor"
                @click="down(scope.row)"
              ></i>
              <i
                v-if="scope.row.courseType == 2"
                v-auth="
                  'classRoomTeaching_/attachmentObject/deleteAttachmentRecording'
                "
                style="font-size: 16px"
                class="el-icon-delete mainColor"
                @click="deleteVideo(scope.row)"
              ></i>
              <!-- <span class="operation-style" @click="edit(scope.row)">编辑</span>
              <span class="operation-style" @click="down(scope.row)">下载</span>
              <span class="operation-style" @click="deleteVideo(scope.row)"
                >删除</span
              > -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="videoDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="70%"
    >
      <videoMaterial @videoListChange="videoListChange"></videoMaterial>
    </el-dialog>

    <el-dialog
      title="编辑视频"
      :visible.sync="editPhotoVisible"
      width="400px"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="editPhotoForm"
        :model="editPhotoForm"
        :label-width="formLabelWidth"
        :rules="editPhotoFormRules"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            style="width: 100%"
            v-model="editPhotoForm.name"
            placeholder="请输入视频名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editPhotoVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateAttachment()">确 定</el-button
        ><!-- :loading="updateAttachmentBlock" -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import videoMaterial from "../common/videoMaterial";
export default {
  components: { videoMaterial },
  props: {
    scheduleInfoId: {
      type: String,
      default: "",
    },
    videoList: {
      type: Array,
    },
  },
  data() {
    return {
      videoDialog: false,
      editPhotoVisible: false,
      editPhotoForm: {},
      formLabelWidth: "80px",
      // updateAttachmentBlock: false,
      editPhotoFormRules: {
        name: [
          {
            required: true,
            message: "请输入视频名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 16,
            message: "视频名称长度在1到16个字",
          },
        ],
      },
    };
  },
  computed: {},
  created() {},
  methods: {
    // 上传视频组件传出方法
    videoListChange(ids) {
      this.$emit("videoListChange", ids);
      this.videoDialog = false;
    },
    updateAttachment() {
      this.$refs.editPhotoForm.validate((Boolean) => {
        if (Boolean) {
          this.$emit("updateAttachment", this.editPhotoForm);
          this.editPhotoVisible = false;
        } else this.$message.error("输入视频名称不对");
      });
    },
    edit(data) {
      this.editPhotoForm = {
        id: data.attachment.id,
        name: data.attachment.name,
      };
      this.editPhotoVisible = true;
    },
    // 下载视频
    down(row) {
      let x = new XMLHttpRequest();
      x.open("GET", row.attachment.url, true);
      x.responseType = "blob";
      x.onload = function (e) {
        if (x.readyState === 4 && x.status === 200) {
          let blob = this.response;
          // 转换一个blob链接
          let u = window.URL.createObjectURL(new Blob([blob]));
          let a = document.createElement("a");
          a.download = row.attachment.name + "." + row.attachment.type;
          a.href = u;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
        // download(x.response, row.name, "video/mp4");
      };
      x.send();
      // window.open(row.url);
    },
    deleteVideo(data) {
      this.$emit("deleteVideo", data);
    },
    selectionVideoChange(val) {
      let ids = [];
      let obj = {};
      val.forEach((e) => {
        ids.push({ id: e.id });
      });
      this.$emit("selectionVideoChange", ids);
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style lang="less" rel="stylesheet/less"></style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/video.vue